import { render, staticRenderFns } from "./OnGoingProjectsSection.vue?vue&type=template&id=9074ac0a&scoped=true&"
import script from "./OnGoingProjectsSection.vue?vue&type=script&lang=js&"
export * from "./OnGoingProjectsSection.vue?vue&type=script&lang=js&"
import style0 from "./OnGoingProjectsSection.vue?vue&type=style&index=0&id=9074ac0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9074ac0a",
  null
  
)

export default component.exports